import {showError} from "../../js/main";
import {isPdfFilename} from "../../js/util";

const PDF_MIME_TYPES = new Set([
    "application/pdf",
    "application/x-pdf",
    "application/acrobat",
    "applications/vnd.pdf",
    "text/pdf",
    "text/x-pdf"
]);

export const getFileMimeType = (file) => {
    const fileName = file.name?.toLowerCase() || "";
    let mime = file.type?.toLowerCase() || "";

    if (!mime && (fileName.endsWith(".heic") || fileName.endsWith(".heif"))) {
        return "image/heic";
    }

    if (PDF_MIME_TYPES.has(mime) ||
        (isPdfFilename(fileName) && (!mime || mime === "application/octet-stream"))) {
        return "application/pdf";
    }

    return mime;
};

export const verify = (accept, maxMBSize, e) => {
    return new Promise((resolve, reject) => {
        const files = e.target.files;

        if (!files || files.length === 0) {
            return resolve(null);
        }

        if (files.length > 1) {
            showError("Es darf nur eine Datei gewählt werden!");
            return reject();
        }

        const file = files[0];
        const fileName = file.name?.toLowerCase() || "";
        const mime = getFileMimeType(file);

        // ---- SIZE VALIDATION ----
        if (maxMBSize !== -1 && file.size > maxMBSize * 1024 * 1024) {
            showError(`Dateigröße von ${maxMBSize}MB darf nicht überschritten werden!`);
            return reject();
        }

        // ---- TYPE VALIDATION ----
        if (accept) {
            const allowed = accept
                .split(",")
                .map(a => a.trim().toLowerCase())
                .filter(Boolean);

            const isValid = allowed.some(rule => {
                // Extension check (strict)
                if (rule.startsWith(".")) {
                    return fileName.endsWith(rule);
                }

                // Wildcard MIME (image/*)
                if (rule.endsWith("/*")) {
                    const base = rule.split("/")[0]; // "image"
                    return mime.startsWith(base + "/");
                }

                // Exact MIME match
                return mime === rule;
            });

            if (!isValid) {
                showError("Ungültiger Dateityp");
                return reject();
            }
        }

        resolve(file);
    });
};

export const InputFile = ({name, label, setter, accept, maxMBSize = -1, required = false, disabled = false, concatId = null, innerRef}) => {

    const identifier = concatId ? name + concatId : name;

    return (
        <div className="form-input">
            {label &&
            <label htmlFor={identifier}>
                {label} {required && <span className="primary-link bold">*</span>}
            </label>}
            <input id={identifier}
                   type="file"
                   onChange={e => verify(accept, maxMBSize, e).then((f) => setter(f, name))}
                   disabled={disabled}
                   required={required}
                   accept={accept}
                   ref={innerRef}/>
        </div>
    );

};
